import produce from 'immer';
import { TOrganizi8AppState } from '../organizi8.reducer';
import { MaterialRequestsActions, TRequestActionTypes } from './material-requests.actions';

const initialState: TOrganizi8AppState['materialRequests'] = {
  materialRequestCounts: {
    lastUpdatedAt: null,
    counts: {},
  },
  warehouseMaterialRequests: {},
  materialRequestDetails: {},
  selectedMaterialRequestOrderItem: null,
  addedItemsToSelectedMaterialRequestOrder: {
    FABRIC: {},
    TRIMS: {},
  },
};

export const MaterialRequestsStateReducer = (
  state = initialState,
  action: TRequestActionTypes,
): TOrganizi8AppState['materialRequests'] => {
  switch (action.type) {
    case MaterialRequestsActions.ClearAndFetchMaterialRequestCounts:
      return produce(state, (draft) => {
        draft.materialRequestCounts.counts = {};
      });
    case MaterialRequestsActions.ClearAndFetchMaterialRequestCountsSuccess:
      return produce(state, (draft) => {
        draft.materialRequestCounts.lastUpdatedAt = Date.now();
        draft.materialRequestCounts.counts.res = action.res.materialRequestCounts;
      });
    case MaterialRequestsActions.ClearAndFetchWarehouseMaterialRequests: {
      return produce(state, (draft) => {
        draft.warehouseMaterialRequests = {};
      });
    }
    case MaterialRequestsActions.ClearAndFetchWarehouseMaterialRequestsSuccess: {
      return produce(state, (draft) => {
        draft.warehouseMaterialRequests.res = action.res;
      });
    }
    case MaterialRequestsActions.ClearAndFetchMaterialRequestDetailsSuccess: {
      const { FABRIC, TRIM: TRIMS, receiverLocationId } = action;
      return produce(state, (draft) => {
        draft.materialRequestDetails.res = {
          FABRIC,
          TRIMS,
          receiverLocationId,
        };
      });
    }
    case MaterialRequestsActions.UpdateSelectedMaterialRequestOrder: {
      return produce(state, (draft) => {
        draft.selectedMaterialRequestOrderItem = action.requestItem;
      });
    }
    case MaterialRequestsActions.ClearSelectedMaterialRequestOrderAndMaterialDetails: {
      return produce(state, (draft) => {
        draft.selectedMaterialRequestOrderItem = null;
        draft.materialRequestDetails = {};
      });
    }
    case MaterialRequestsActions.ClearAllAddedItemsInSelectedMaterialRequestOrder: {
      return produce(state, (draft) => {
        draft.addedItemsToSelectedMaterialRequestOrder = {
          FABRIC: {},
          TRIMS: {},
        };
      });
    }
    case MaterialRequestsActions.AddItemsToTheSelectedMaterialRequestOrder: {
      return produce(state, (draft) => {
        draft.addedItemsToSelectedMaterialRequestOrder[action.itemType][action.itemUniqueKey] = action.items;
      });
    }
    default:
      return state;
  }
};
